<template>
  <div>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="mr-1 per-page-selector d-inline-block ml-50"
          />
          <b-button class="mr-1" variant="primary" :to="{ name: 'admin-pcc-add' }">
            Add New PCC
          </b-button>

          <b-button @click="exportToExcel(
                pcc,
                ['Date', 'Event', 'Product', 'Speakers', 'Participant', 'Acara', 'Narasumber', 'Materi'],
                ['date', 'event', 'product', 'speakers', 'participant', 'acara', 'narasumber', 'materi'],
                ['List PCC'],
                formatJson
              )" variant="primary"
              >Export Excel</b-button
            >
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
        >
          <label class="mr-1">
            Search
          </label>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              class="mr-1 d-inline-block"
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Larger screen than mobile -->
    <div class="d-none d-md-flex">
      <b-table
        class="w-100 border"
        no-local-sorting
        @sort-changed="sortingChanged"
        responsive
        striped
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items="pcc"
        :fields="pccFields"
      >
        <template #cell(event)="pccItem">
          <b-button variant="link" style="text-align:left" @click="showRating(pccItem.item.id)">
            {{ pccItem.item.title }}
          </b-button>
        </template>
        <template #cell(participant)="pccItem">
            {{ pccItem.item.participants_count }}
        </template>
        <template #cell(speakers)="pccItem">
          <ul v-for="speaker in pccItem.item.speakers" :key="speaker.id">
            <li>{{ speaker.speaker }}</li>
          </ul>
        </template>
        <template #cell(products)="pccItem">
          <ul v-for="product in pccItem.item.pcc_products" :key="product.id">
            <li>{{ product.product.PRODUCT }}</li>
          </ul>
        </template>
        <template #cell(open)="pccItem">
          <b-form-checkbox
            v-model="pccItem.item.is_open"
            class="custom-control-danger"
            name="check-button"
            switch
            @change="onOpenChange(pccItem.item.id, $event)"
            :unchecked-value="false"
          />
        </template>
        <template #cell(publish_banner_image_history)="pccItem">
          <div @click="onPublishHistoryToggleClick(pccItem.item)">
            <b-form-checkbox
              v-model="pccItem.item.publish_banner_image_history"
              class="custom-control-danger"
              name="check-button"
              switch
              :disabled="!pccItem.item.banner_image_history"
              :title="!pccItem.item.banner_image_history ? 'Upload Banner History on the Edit page first' : ''"
              @change="onPublishBannerHistoryChange(pccItem.item.id, $event)"
              :unchecked-value="false"
            />
          </div>
        </template>
        <template #cell(action)="pccItem">
          <div class="d-flex justify-content-between">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="mr-1 btn-icon"
              :to="{ name: 'admin-pcc-edit', params: { pccId: pccItem.item.id } }"
            >
              <feather-icon icon="Edit3Icon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="mr-1 btn-icon"
              @click="showMsgBoxDelete(pccItem.item.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- Mobile screen -->
    <div class="d-flex d-md-none flex-column">
      <!-- Loading -->
      <div v-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
        <strong class="text-secondary">Loading...</strong>
      </div>
      <!-- Data -->
      <div v-if="!isBusy && pcc.length == 0" class="text-center text-danger my-2">
        <strong class="text-secondary">No data</strong>
      </div>
      <b-row
        v-if="!isBusy && pcc.length > 0"
        v-for="(item, index) in pcc"
        :key="item.id"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">
            <a style="color: #d92c2f; text-align: left" @click="showRating(item.id)">
              {{ item.title }}
            </a>
          </strong>
          <div class="d-flex flex-wrap align-items-center">
            <b-form-checkbox
              v-model="item.is_open"
              name="check-button"
              switch
              @change="onOpenChange(item.id, $event)"
              :unchecked-value="false"
            />
            <div class="ml-1" @click="onPublishHistoryToggleClick(item)">
              <b-form-checkbox
                v-model="item.publish_banner_image_history"
                name="check-button"
                switch
                :disabled="!item.banner_image_history"
                :title="!item.banner_image_history ? 'Upload Banner History on the Edit page first' : ''"
                @change="onPublishBannerHistoryChange(item.id, $event)"
                :unchecked-value="false"
              />
            </div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="mr-1 btn-icon"
              :to="{ name: 'admin-pcc-edit', params: { pccId: item.id } }"
            >
              <feather-icon icon="Edit3Icon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="mr-1 btn-icon"
              @click="showMsgBoxDelete(item.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </b-col>
        <b-col cols="12" class="d-flex flex-wrap">
          <div style="font-size: 0.75rem;">
            <p><strong>DATE: </strong>{{ $moment(item.start_datetime).format('D-M-Y') }}</p>
            <p><strong>PRODUCTS: </strong></p>
            <ul v-for="product in item.pcc_products" :key="product.id">
              <li>{{ product.product.PRODUCT }}</li>
            </ul>
            <p><strong>SPEAKERS: </strong></p>
            <ul v-for="speaker in item.speakers" :key="speaker.id">
              <li>{{ speaker.speaker }}</li>
            </ul>
            <p><strong>PARTICIPANT: </strong>{{ item.participants_count }}</p>
            <p><strong>ACARA: </strong>{{ Number(item.ratings_avg_event_rate).toFixed(2) }}</p>
            <p><strong>NARASUMBER: </strong>{{ Number(item.ratings_avg_speaker_rate).toFixed(2) }}</p>
            <p><strong>MATERI: </strong>{{ Number(item.ratings_avg_material_rate).toFixed(2) }}</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.total }} entries
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal hide-footer title="Participants" size="xl" id="participant-modal">
      <participant-pcc-table :pccId="selectedPCC" />
    </b-modal>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import VSelect from 'vue-select'
import {
  BSpinner,
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
  BButton,
  BFormInput,
  BPagination,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ParticipantPccTable from '@/views/admin/pcc/ParticipantPCCTable'

export default {
  components: {
    BSpinner,
    BTable,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    VSelect,
    BFormInput,
    BPagination,
    BModal,
    ParticipantPccTable,
  },

  directives: {
    Ripple,

    VBModal,
  },

  data() {
    return {
      sortBy: 'start_datetime',
      sortDesc: true,
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      pcc: [],
      pccFields: [
        {
          key: 'start_datetime',
          formatter: (value, key, item) => {
            return this.$moment(value).format('D-M-Y')
          },
          label: 'Date',
          sortable: true,
        },
        'event',
        'products',
        'speakers',
        'participant',
        {
          key: 'ratings_avg_event_rate',
          formatter: (val, key, item) => {
            return Number(val).toFixed(2)
          },
          label: 'Acara',
          sortable: true,
        },
        {
          key: 'ratings_avg_speaker_rate',
          formatter: (val, key, item) => {
            return Number(val).toFixed(2)
          },
          label: 'Narasumber',
          sortable: true,
        },
        {
          key: 'ratings_avg_material_rate',
          formatter: (val, key, item) => {
            return Number(val).toFixed(2)
          },
          label: 'Materi',
          sortable: true,
        },
        'open',
        {
          key: 'publish_banner_image_history',
          label: 'Publish History',
        },
        'action',
      ],
      selectedPCC: '',
      searchWord: '',
    }
  },

  watch: {
    perPage() {
      this.fetchPcc()
    },
    currentPage() {
      this.fetchPcc()
    },
    searchWord(newVal) {
      this.searchByTitle()
    },
  },

  mounted() {
    this.fetchPcc()
  },

  methods: {
    fetchPcc() {
      this.isBusy = true

      this.$http
        .get('/pcc/product', {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            s: this.searchWord.toString().trim(),
            sort: `${this.sortDesc ? '-' : ''}${this.sortBy}`,
          },
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.pcc = data.data
        })
        .finally(() => {
          this.isBusy = false
        })
    },

    searchByTitle: debounce(function() {
      this.fetchPcc()
    }, 200),

    onOpenChange(pccId, isOpen) {
      const openUrl = isOpen ? `/pcc/open/${pccId}` : `/pcc/close/${pccId}`
      this.$http
        .post(openUrl)
        .then(() => {
          this.$notif(
            'Success',
            `PCC has been successfully ${isOpen ? 'opened' : 'closed'}.`,
            'success'
          )
          this.fetchPcc()
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
    },

    onPublishHistoryToggleClick(item) {
      // The toggle is :disabled when there's no banner_image_history, so its own
      // @change never fires in that case. Catch the click on the wrapper instead
      // and tell the admin why nothing happened.
      if (!item.banner_image_history) {
        this.$notif(
          'Error',
          'Banner History has not been uploaded yet. Upload it on the Edit page before you can publish it.',
          'error'
        )
      }
    },

    onPublishBannerHistoryChange(pccId, isActive) {
      // PUT /pcc/product/{id} bukan partial update: field dasar PCC tetap wajib
      // ikut dikirim, jadi ambil detailnya dulu lalu kirim ulang dengan flag baru.
      // Field banner sengaja tidak disertakan supaya file yang ada tidak berubah.
      this.$http
        .get(`/pcc/product/${pccId}`)
        .then(({ data }) => {
          const pcc = data.data
          const speakers = pcc.speakers || []

          return this.$http.put(`/pcc/product/${pccId}`, {
            title: pcc.title,
            start_datetime: this.$moment(pcc.start_datetime).format(
              'YYYY-MM-DD HH:mm'
            ),
            end_datetime: this.$moment(pcc.end_datetime).format(
              'YYYY-MM-DD HH:mm'
            ),
            description: pcc.description,
            address: pcc.address,
            link: pcc.link,
            speakers: speakers.map(speaker => speaker.speaker),
            speaker_positions: speakers.map(speaker => speaker.position),
            categories_id: (pcc.categories || []).map(cat => cat.category.id),
            products_kode: (pcc.pcc_products || []).map(
              prod => prod.product.KODE
            ),
            pcc_video: (pcc.video || []).map(video => ({
              uuid: video.uuid,
              path: video.path,
            })),
            attachments: [],
            publish_banner_image_history: isActive,
          })
        })
        .then(() => {
          this.$notif(
            'Success',
            `Banner History has been successfully ${isActive ? 'published' : 'unpublished'}.`,
            'success'
          )
          this.fetchPcc()
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
          // Kembalikan posisi toggle ke nilai di server
          this.fetchPcc()
        })
    },

    changePage(page) {
      this.currentPage = page
    },

    sortingChanged({ sortBy, sortDesc }) {
      ;(this.sortBy = sortBy), (this.sortDesc = sortDesc)
      this.fetchPcc()
    },

    deletePCC(pccId) {
      return this.$http.delete(`pcc/product/${pccId}`)
    },

    showMsgBoxDelete(pccId) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.deletePCC(pccId)
              .then(() => {
                this.$notif(
                  'Success',
                  'PCC has been successfully deleted.',
                  'success'
                )
                this.fetchPcc()
              })
              .catch(err => {
                this.$notif('Error', `${err.message}`, 'error')
              })
          }
        })
    },

    showRating(pccId) {
      this.selectedPCC = pccId
      this.$bvModal.show('participant-modal')
    },

    exportToExcel (records, headers, fieldVal, filename, formatJson) {
      import('@/libs/Export2Excel').then(excel => {
          const list = records
          const data = formatJson(fieldVal, list)
          excel.export_json_to_excel({
            header: headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data = v[j]

        if (j === 'date') {
          data = this.$moment(v.start_datetime).format('D-M-Y')
        }

        if (j === 'event') {
          data = v.title
        }
        
        if (j === 'product') {
          data = v.pcc_products.map(prod => prod.product.PRODUCT).toString()
        }
        
        if (j === 'speakers') {
          data = v.speakers.map(speak => speak.speaker).toString()
        }
        
        if (j === 'participant') {
          data = v.participants_count
        }
        
        if (j === 'acara') {
          data = Number(v.ratings_avg_event_rate).toFixed(2)
        }
        
        if (j === 'narasumber') {
          data = Number(v.ratings_avg_speaker_rate).toFixed(2)
        }
        
        if (j === 'materi') {
          data = Number(v.ratings_avg_material_rate).toFixed(2)
        }

        return data
      }))
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
